// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{display:inline-block}#payment-submit-button{position:absolute;top:-9000px;left:-9000px}", ""]);
// Exports
module.exports = exports;
